import * as Actions from './customers.selected-customers.actions';
import { emptyArray } from 'ui-components/default-props/empty';

const initialState = {
  selectedCustomerIds: emptyArray,
};

export const reduce = (state = initialState, action) => {
  const { selectedCustomerIds } = action;
  switch (action.type) {
    case Actions.SET_SELECTED_CUSTOMERS:
      return {
        ...state,
        selectedCustomerIds,
      };
    default:
      return state;
  }
};

export { namespace } from './customers.selected-customers.reducer.metadata';
